import { PlusOutlined, QuestionCircleOutlined } from '@ant-design/icons'
import { Button, Modal, Space, Tag, Tooltip, message } from 'antd'
import { inject, observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import { useHistory } from 'react-router-dom'
import { blue } from '../../color'
import TableComponent from '../../components/Common/TableComponent'
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import PageTitle from '../../components/PageTitle'
import SelectPeoplePopup from '../../components/SelectPeoplePopup/SelectPeoplePopup'
import { ACL_TYPE, ASSIGNEE_TYPE } from '../../constants'
import DashboardLayout from '../../layouts/DashboardLayout/DashboardLayout'
import { AppTable } from '../../components/AppTable/AppTable'
import {
  AddCircleOutlineIcon,
  CopyOutlineIcon,
  TrashBin2OutlineIcon,
  UserPlusBrokenIcon,
} from '../../components/AppIcon'
import AppPageHeader from '../../components/AppPageHeader'

const { confirm } = Modal

const ACLPage = props => {
  const { aclStore, selectPeopleStore, userStore, authenticationStore } = props

  const { aclGroupList } = aclStore

  const [aclGroupListPO, setAclGroupListPO] = useState()

  useEffect(() => {
    setAclGroupListPO(
      aclGroupList.filter(item => (item.code.slice(0, 3) === 'HR_') === false)
    )
  }, [aclGroupList])

  const {
    selectUserData,
    selectDepartmentData,
    originDepartmentWithUserList,
  } = selectPeopleStore

  const history = useHistory()

  const [isLoadingTable, setIsLoadingTable] = useState(false)
  const [isVisibleSelectModal, setIsVisibleSelectModal] = useState(false)
  const [aclActive, setAclActive] = useState()
  const [isOpening, setIsOpening] = useState(false)

  useEffect(() => {
    ;(async () => {
      try {
        setIsLoadingTable(true)
        await selectPeopleStore.getDepartmentWithUsers()
        await aclStore.getACLGroupList()
      } catch (err) {
        console.log(err)
        message.error(err.vi || 'Đã có lỗi xảy ra!')
      } finally {
        setIsLoadingTable(false)
      }
    })()
    return () => {
      aclStore.clearAclGroupList()
    }
  }, [authenticationStore.currentUser])

  const handleDeleteACL = async code => {
    try {
      setIsLoadingTable(true)
      await aclStore.deleteACLGroup(code)
      await aclStore.getACLGroupList()
      message.success('Đã xóa!')
    } catch (err) {
      console.log(err.vi || 'Đã có lỗi xảy ra!')
    } finally {
      setIsLoadingTable(false)
    }
  }

  const handleCloneACL = async code => {
    try {
      setIsLoadingTable(true)
      await aclStore.cloneACLGroup(code)
      await aclStore.getACLGroupList()
      message.success('Nhân bản thành công!')
    } catch (err) {
      console.log(err.vi || 'Đã có lỗi xảy ra!')
    } finally {
      setIsLoadingTable(false)
    }
  }

  const handleSubmitSelectUser = async () => {
    const users = []
    selectUserData[ASSIGNEE_TYPE.HANDLER].forEach(item => {
      users.push(item.id)
    })
    selectDepartmentData[ASSIGNEE_TYPE.HANDLER].forEach(item => {
      const userList =
        originDepartmentWithUserList.find(el => el.code === item.id)?.users ||
        []
      userList.forEach(user => {
        users.push(user.user_name)
      })
    })
    const payload = {
      users: users,
      acl_group_code: aclActive,
    }
    setIsVisibleSelectModal(false)
    try {
      setIsOpening(true)
      await aclStore.assignACLGroup(payload)
      selectPeopleStore.clearSelected()
      setAclActive(null)
      message.success('Áp dụng thành công!')
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra!')
    } finally {
    }
  }

  const handleOpenSelectPeoplePopup = type => {
    selectPeopleStore.setAssigneePopupType(type)
    setIsVisibleSelectModal(true)
  }

  const renderTag = type => {
    if (type === ACL_TYPE.DEFAULT) {
      return (
        <Tag
          color={'blue'}
          style={{ borderRadius: 4, border: 'none', padding: '4px 8px' }}>
          Hệ thống
        </Tag>
      )
    }
    if (type === ACL_TYPE.CUSTOM) {
      return (
        <Tag
          color={'orange'}
          style={{ borderRadius: 4, border: 'none', padding: '4px 8px' }}>
          Tùy chỉnh
        </Tag>
      )
    }
    return (
      <Tag
        color={'purple'}
        style={{ borderRadius: 4, border: 'none', padding: '4px 8px' }}>
        {type}
      </Tag>
    )
  }

  const handleAOpenApDung = async record => {
    setAclActive(record.code)
    try {
      setIsOpening(true)
      const res = await aclStore.getACLDetail(record.code)
      console.log(res.data.assigned_users)
      const assignedUsers = res.data.assigned_users
      const assignedUsersData = []
      assignedUsers.forEach(item => {
        originDepartmentWithUserList.forEach(el => {
          el.users.forEach(user => {
            if (user.user_name === item) {
              assignedUsersData.push({
                id: user.user_name,
                assignee_type: ASSIGNEE_TYPE.USER,
                full_name: user.name_uppercase,
                permission: ASSIGNEE_TYPE.HANDLER,
                department_code: el.code,
                department_name: el.name,
              })
            }
          })
        })
      })
      selectPeopleStore.setSelectUserData({
        [ASSIGNEE_TYPE.HANDLER]: assignedUsersData,
        [ASSIGNEE_TYPE.COMBINER]: [],
        [ASSIGNEE_TYPE.FOLLOWER]: [],
        [ASSIGNEE_TYPE.LEADER]: [],
      })
      handleOpenSelectPeoplePopup(ASSIGNEE_TYPE.HANDLER)
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra!')
    } finally {
      setIsOpening(false)
    }
  }

  const showConfirm = code => {
    confirm({
      title:
        'Bạn có chắc chắn muốn xóa nhóm phân quyền này. Những người trong nhóm này sẽ tự động được chuyển sang nhóm mặc định Người dùng thường ?',
      icon: <QuestionCircleOutlined style={{ color: 'red' }} />,
      okText: 'Xóa',
      cancelText: 'Không',
      okType: 'danger',
      onOk: async () => {
        await handleDeleteACL(code)
      },
    })
  }

  const columns = [
    {
      title: 'Quyền người dùng',
      render: record => <span>{record.name}</span>,
    },
    {
      align: 'center',
      title: 'Loại',
      render: record => renderTag(record.type),
    },
    {
      title: 'Thao tác',
      key: 'action',
      align: 'center',
      render: record => (
        <Space size="middle" onClick={e => e.stopPropagation()}>
          <Tooltip title="Áp dụng quyền cho người dùng">
            <Button
              icon={<UserPlusBrokenIcon style={{ width: 18, height: 18 }} />}
              shape="circle"
              disabled={isOpening && record.code === aclActive}
              type={'text'}
              style={{ color: blue }}
              onClick={() => handleAOpenApDung(record)}
            />
          </Tooltip>

          <Tooltip title="Nhân bản quyền">
            <Button
              icon={<CopyOutlineIcon style={{ width: 18, height: 18 }} />}
              shape="circle"
              onClick={() => handleCloneACL(record.code)}
              type={'text'}
              style={{ color: blue }}
            />
          </Tooltip>

          <Tooltip title="Xóa quyền">
            <Button
              icon={<TrashBin2OutlineIcon style={{ width: 18, height: 18 }} />}
              type={'text'}
              shape="circle"
              onClick={() => showConfirm(record.code)}
              danger
              disabled={record.type === ACL_TYPE.DEFAULT}
            />
          </Tooltip>
        </Space>
      ),
    },
  ]

  return (
    <DashboardLayout>
      <Helmet>
        <title>Quản lý phân quyền</title>
      </Helmet>

      <AppPageHeader
        title={'Quản lý phân quyền'}
        addon={
          <Button
            icon={
              <AddCircleOutlineIcon
                style={{ color: '#fff', width: 16, height: 16 }}
              />
            }
            onClick={() => history.push('/acl/create')}
            type={'primary'}
            className="custom-ant-button icon-btn">
            Tạo mới
          </Button>
        }
      />

      <div style={{ minHeight: 'calc(100vh - 150px)' }}>
        <AppTable
          rowKey={'code'}
          loading={isLoadingTable}
          columns={columns}
          dataSource={aclGroupListPO}
          onRow={record => {
            return {
              onClick: () => history.push(`/acl/view/${record.code}`),
            }
          }}
        />
      </div>

      <SelectPeoplePopup
        isOpenCollapse
        noLoadSelectData
        allowChangeCompany={false}
        title={`Áp dụng quyền`}
        okText={'Áp dụng'}
        handleCancelSelectUser={() => {
          setIsVisibleSelectModal(false)
          selectPeopleStore.clearSelected()
          setAclActive(null)
        }}
        handleSubmitSelectUser={handleSubmitSelectUser}
        isVisibleSelectPeoplePopup={isVisibleSelectModal}
      />
    </DashboardLayout>
  )
}

ACLPage.propTypes = {}

export default inject(
  'aclStore',
  'selectPeopleStore',
  'userStore',
  'authenticationStore'
)(observer(ACLPage))
